import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function Advantages({ advantagesData }) {

    const AdvantList = [
        {
            id: 1,
            title: 'Зростання під тиском',
            text: 'На саміті поговоримо про те, як компанії перебудовують бізнес-моделі, коли тиск не зникає, а стає фоном. Які управлінські рішення дозволяють утримувати темп і знаходити точки росту саме в складних умовах.',
        },
        {
            id: 2,
            title: 'Білий бізнес як стратегія',
            text: 'У часи, коли прозорість перестає бути формальністю і починає працювати як доступ до фінансування, партнерств і нових ринків, управління потребує системних змін.',
        },
        {
            id: 3,
            title: 'Енергоефективність як рішення власника',
            text: 'Обговоримо, як інвестиції в енергоефективність перетворюються на контроль витрат, операційну незалежність і прогнозованість, а не залишаються елементом ESG-риторики.',
        },
        {
            id: 4,
            title: 'Захист активів у реальності війни',
            text: 'Як саме реальні механізми захисту бізнесу існують у часи турбулентності: що можна мінімізувати, що — застрахувати, а де потрібні нові підходи до управління ризиками та відповідальністю.',
        },
        {
            id: 5,
            title: 'Практичний ШІ для бізнесу',
            text: 'Розберемо кейси, де ШІ вже допомагає знижувати ризики, посилювати контроль і підвищувати ефективність — без хайпу і зайвих експериментів.',
        },
        {
            id: 6,
            title: 'Соціальна відповідальність у нових умовах',
            text: 'Обговоримо, як змінюються очікування суспільства до бізнесу, де проходить межа між репутацією і реальним впливом та як це впливає на довіру до компаній.',
        },
        {
            id: 7,
            title: 'Фінансування бізнесу у 2026 році',
            text: 'Реальні джерела капіталу: банки, фонди, партнерства й альтернативні інструменти — і умови, за яких бізнесу готові довіряти ресурси.',
        },
        {
            id: 8,
            title: 'Бізнеси Сміливих',
            text: 'Обговоримо рішення компаній, які зростають без очікування «кращих часів»: нові підходи до масштабування, партнерств і відповідальності в умовах постійної невизначеності.'
        },
        {
            id: 9,
            title: 'Євроінтеграція та експорт без ілюзій',
            text: 'Як змінюється логіка експорту до ЄС: від управлінських процесів і стандартів до відповідальності власників і команд.'
        }
    ];


    return (
        advantagesData ?
            <section className="relative mb-[60px] md:mb-[120px]">

                <div className="container max-w-screen-xl mx-auto px-[15px]">
                    <h2 className="text-3xl uppercase text-center font-bold mb-8 lg:m-14 lg:text-[42px] xl:text-[52px]">ЕКСПЕРТНІ ДІАЛОГИ</h2>


                    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
                        {AdvantList.map(({ id, title, text }) => (
                            <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                                <div key={id} className="bg-white pb-10 px-5 lg:px-8 lg:pb-11 md:h-full">

                                    <div className="bg-[linear-gradient(110deg,_#009064_0%,_#46a37e_50.41%,_#e6e47c_100%)]
                                        w-16 h-16 flex flex-col items-center justify-center text-white text-base font-medium mb-11">
                                        <span className="font-bold text-[40px] leading-none">{id}</span>
                                        тема
                                    </div>

                                    <h3 className="font-bold text-2xl mb-4">{title}</h3>

                                    <p className="text-[#6e6e6e] text-lg font-light">
                                        {text}
                                    </p>
                                </div>
                            </ScrollAnimation>
                        ))}
                    </div>


                </div>

            </section> : ''
    )

}


export default Advantages